import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGetPackagesQuery } from "../../Redux/Apis/packageApi";
import Loading from "../../Layouts/Loading";
import { fa_currency, fa_number } from "../../utils/Persian";
import { useEffect, useState } from "react";
import Payment from "../../Sections/panel/exam/Payment";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";

function Package() {
    const [paymentPopup,setPaymentPopup] = useState(false)
    const [paymentId,setPaymentId] = useState(0)
    const { data , isLoading , isSuccess } = useGetPackagesQuery()
    const [verifyStatus, setVerifyStatus] = useState(-1)
    const [auth, setAuth] = useState('')
    const [searchParams] = useSearchParams()
    const navigate = useNavigate();
    const PaymentStatus = searchParams.get("status") ? searchParams.get("status") : null;
    const Authority = searchParams.get("auth") ? searchParams.get("auth") : null;

    useEffect(() => {
        if (PaymentStatus) {
            setVerifyStatus(PaymentStatus === '1' ? 1 : 0); 
            if (Authority) setAuth(Authority)
            navigate(`/panel/package`, { replace: true });
        }
      }, [Authority, PaymentStatus, navigate])

    return (
        <>
        <main className="col-lg-9">
            <div className="panel-surface p-3 mb-3 d-flex align-items-center justify-content-between">
                <h6 className="fw-bold m-0">خرید اشتراک سایت</h6>
                <span className="panel-muted small">انتخاب و پرداخت پکیج‌ها</span>
            </div>

            <div className="panel-surface p-2">
                <div className="container-fluid">
                    {verifyStatus === 1 && <div className="alert alert-success mt-2 mb-4 p-5 text-center" role="alert">
                        <h6>صورتحساب شما با موفقیت پرداخت شد و حساب کاربریتان شارژ گردید.</h6>
                        {auth !== '' && <u>شناسه پیگیری پرداخت شما: {auth}</u>}
                    </div>}

                    {verifyStatus === 0 && <div className="alert alert-danger mt-2 mb-4 p-5 text-center" role="alert">
                        <h6 >پرداخت با مشکل مواجه شد لطفا مجددا تلاش نمایید.</h6>
                        {auth !== '' && <u>شناسه پیگیری پرداخت شما: {auth}</u>}
                    </div>}

                    {isLoading && <Loading />}
                    {isSuccess && data && data.map((row,index) => {
                        const rialPayable = row.rial_sale_price !== undefined && row.rial_sale_price !== null
                            ? Number(row.rial_sale_price)
                            : Number(row.rial_price);
                        const isRialZero = !rialPayable || rialPayable <= 0;

                        return (
                        <div className="col-12 mb-2" key={index}>
                            <div className="panel-surface border-0 shadow-sm p-2 position-relative">
                                {row.popular && <span className="position-absolute top-0 start-100 badge rounded-end bg-success z-3 p-2" style={{margin:"10px -70px"}}>
                                    <FontAwesomeIcon icon="star" className="text-warning me-2 align-middle"/>
                                    پرطرفدار
                                    <span className="visually-hidden">پرطرفدار</span>
                                </span>}
                                <h6 className={`fw-bold mb-1 ${row.is_premium ? "text-danger" : ""}`}><FontAwesomeIcon icon="certificate" className="me-1"/> {row.name}</h6>
                                <p className="text-muted small mt-1 mb-2">{row.note}</p>
                                
                                {row.pros && row.pros.split(',').map((row,index) => 
                                    <p className="mb-1 small" key={index}>
                                        <FontAwesomeIcon icon="circle-check" className="text-success f-18 me-1"/>
                                        {row}                                   
                                    </p>
                                )}
                                {row.cons && row.cons.split(',').map((row,index) => 
                                    <p className="mb-1 small" key={index}>
                                        <FontAwesomeIcon icon="circle-xmark" className="text-danger f-18 me-1"/>
                                        {row}                                   
                                    </p>
                                )}
                                {row.dollar_price !== 0 && <p className="mb-1 small">
                                    <FontAwesomeIcon icon="money-bill-wave" className="f-18 me-2"/>
                                    {row.dollar_sale_price !== null ? <>
                                        سفارش پکیج: <del>{row.dollar_price}</del> {row.dollar_sale_price} تتر
                                    </> : <>
                                    سفارش پکیج: {row.dollar_price} تتر
                                    </>}
                                </p>}
                                {row.dollar_price !== 0 && <p className="mb-1 small">
                                    <FontAwesomeIcon icon="money-bill-wave" className="f-18 me-2"/>
                                    {row.rial_sale_price !== null ? <>
                                        سفارش پکیج: <del>{fa_currency(+row.rial_price)}</del> {fa_currency(row.rial_sale_price ? +row.rial_sale_price : 0)} تومان
                                    </> : <>
                                    سفارش پکیج: {fa_currency(+row.rial_price)} تومان
                                    </>}
                                </p>}
                                {row.day && <p className="mb-1 small">
                                    <FontAwesomeIcon icon="calendar-day" className="f-18 me-2"/>
                                    طول دوره: {fa_number(row.day)} روز
                                </p>}
                                <div className="text-end">
                                    {row.dollar_price === 0 ? (
                                        <div className="m-2">
                                            <button disabled className="btn btn-success text-center">
                                                <FontAwesomeIcon icon="circle-check" className="fs-3" />
                                                <p className="m-0">پکیج پیشفرض سیستم</p>
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="m-2">
                                            <button
                                                disabled={isRialZero}
                                                onClick={() => {
                                                    if (isRialZero) return;
                                                    if (row.status === 'ACTIVE') {
                                                        setPaymentId(row.id);
                                                        setPaymentPopup(true);
                                                    } else {
                                                        toast.warning('خرید این پکیج در حال حاضر غیر فعال می باشد.');
                                                    }
                                                }}
                                                className={`btn btn-sm ${isRialZero ? "btn-secondary" : (row.is_premium ? "btn-danger" : "btn-primary")} btn-rounded`}
                                            >
                                                <FontAwesomeIcon icon="square-check" className="me-2" />
                                                {isRialZero ? 'پکیج پیشفرض به صورت رایگان فعال است' : `انتخاب ${row.name}`}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )})}
                </div>
            </div>
        </main>

        {paymentPopup && <Payment id={paymentId} close={setPaymentPopup}/>}
        </>
     );
}

export default Package;
